/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1c0e74bffea67b610c867ef86037e15>>
 * @codegenCommand yarn build tokens
 */
export default `
html[data-theme~="shape:shape"] {
  --ds-radius-xsmall: 0.125rem;
  --ds-radius-small: 0.25rem;
  --ds-radius-medium: 0.375rem;
  --ds-radius-large: 0.5rem;
  --ds-radius-xlarge: 0.75rem;
  --ds-radius-full: 624.9375rem;
  --ds-radius-tile: 25%;
  --ds-border-width: 0.0625rem;
  --ds-border-width-selected: 0.125rem;
  --ds-border-width-focused: 0.125rem;
}
`;